import {ZMESSAGE, ZOBJECT} from "constants/object-types.js"

export const quickRefresh = (node, visited=new Set()) => {
    if (window.noReload) {
        return;
    }
    if (node.previousArgs && node.lastMessageReceived !== undefined) {
        node.args = node.previousArgs;
        node.refresh();
        return;
    } 
}

export const hotReloadNode = (node, visited=new Set()) => {
    if (window.noReload) {
        return;
    }
    if (node.skipHotReload) {
        if (node.hotReload) {
            node.hotReload();
        }
        return;
    }
    let isSubPatch = node.zObject && node.zObject.name === "subpatch";

    if (visited.has(node)) {
        return;
    }


    // go up the tree
    let count = 0;
    let nodes = [];

    if (isSubPatch) {
        visited.add(node);
        for (let outlet of node.outletObjects) {
            hotReloadNode(outlet, visited);
        }
        return;
    } else if (node.isInlet) {
        let _node = node.subSequence;
        let type = "Input " + node.inletNumber;
        if (_node.inlets[type]) {
            let {connections} = _node.inlets[type];
            nodes = [
                ... nodes,
                ... connections.map(x => x.sourceNode)
            ];
            count += connections.length;
        }
    } else {
        for (let type in node.inlets) {
            let {connections} = node.inlets[type];
            let _nodes = [... connections.map(x => x.sourceNode)];
            nodes = [
                ... nodes,
                ... _nodes
            ];
            count += connections.length;
    }
    }

    let type = node.getObjectType && node.getObjectType();
    if (visited.size > 0) {
        if (type === ZMESSAGE) {
            if (node.lastSentMessage && !node.isOutlet && !node.isInlet) {
                node.refresh();
                return;
            }
        } else if (type === ZOBJECT) {
            if (node.lastMessageReceived) {
                node.refresh();
                return;
            }
        }
    }

    visited.add(node);

    nodes.forEach(x => hotReloadNode(x, visited));
};
